import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import './plugins/vuetify';
import './plugins/checkout';
import App from './App.vue';
import router from './router';
import store from './store';

const config = {
  apiKey: 'AIzaSyCkTeDImtgXN0fuCc5tCH4Pvryr3pFVfzM',
  authDomain: 'legal-house-67285.firebaseapp.com',
  databaseURL: 'https://legal-house-67285.firebaseio.com',
  projectId: 'legal-house-67285',
  storageBucket: '',
  messagingSenderId: '690296057046',
};
firebase.initializeApp(config);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
  window.__store__ = store; // eslint-disable-line
}

let app = null;
firebase.auth().onAuthStateChanged(() => {
  if (!app)
    app = new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App),
    });
});
